import React from "react";
import { Link } from "react-router-dom";
import { BRAND, OPERATOR, DISCLAIMER } from "@/legal/legalConfig";

/**
 * Sprint 7 — Gemeinsames Layout-Frame für die 4 Rechtsseiten.
 * Bewusst minimalistisch, no-Layout-Wrapper (öffentlich erreichbar).
 */
export default function LegalPageLayout({ title, lastUpdated, children, testid }) {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900" data-testid={testid}>
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-home-link">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-orange-500 to-orange-600 grid place-items-center text-white text-sm font-bold">r</div>
            <span className="font-extrabold tracking-tight text-slate-900" style={{ fontFamily: "Manrope, sans-serif" }}>{BRAND.name}</span>
          </Link>
          <nav className="flex gap-4 text-sm">
            <Link to="/impressum" className="text-slate-600 hover:text-slate-900" data-testid="legal-nav-imprint">Impressum</Link>
            <Link to="/datenschutz" className="text-slate-600 hover:text-slate-900" data-testid="legal-nav-privacy">Datenschutz</Link>
            <Link to="/agb" className="text-slate-600 hover:text-slate-900" data-testid="legal-nav-terms">AGB</Link>
            <Link to="/cookies" className="text-slate-600 hover:text-slate-900" data-testid="legal-nav-cookies">Cookies</Link>
          </nav>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10">
        <div className="mb-5 p-3 rounded-md bg-amber-50 border border-amber-200 text-amber-900 text-xs leading-relaxed" data-testid="legal-disclaimer">
          <strong>Hinweis:</strong> {DISCLAIMER}
        </div>

        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight" style={{ fontFamily: "Manrope, sans-serif" }} data-testid="legal-page-title">
          {title}
        </h1>
        {lastUpdated && (
          <p className="text-xs text-slate-500 mt-2">Stand: {lastUpdated}</p>
        )}

        <article className="mt-6 text-[15px] leading-relaxed legal-content">
          {children}
        </article>

        <footer className="mt-12 pt-6 border-t border-slate-200 text-xs text-slate-500">
          <p>
            Betreiber: <strong>{OPERATOR.legal_name}</strong> · {OPERATOR.street} · {OPERATOR.zip} {OPERATOR.city} · {OPERATOR.country}<br />
            E-Mail: <a href={`mailto:${OPERATOR.email}`} className="underline">{OPERATOR.email}</a> · USt-ID: {OPERATOR.vat_id}
          </p>
        </footer>
      </main>

      <style>{`
        .legal-content h2 { font-size: 18px; font-weight: 700; margin-top: 28px; margin-bottom: 10px; color: #0f172a; }
        .legal-content h3 { font-size: 15px; font-weight: 700; margin-top: 18px; margin-bottom: 6px; color: #0f172a; }
        .legal-content p { margin: 10px 0; color: #334155; }
        .legal-content ul { list-style: disc; padding-left: 22px; margin: 10px 0; color: #334155; }
        .legal-content ul li { margin: 4px 0; }
        .legal-content a { color: #ea580c; text-decoration: underline; }
        .legal-content a:hover { color: #c2410c; }
        .legal-content table { border-collapse: collapse; }
      `}</style>
    </div>
  );
}
